import {CSSProperties, ReactNode} from 'react';

export const Bold = ({ children, style }: BoldProps) => (
  <span className="bold-text" style={style}>{children}</span>
);

interface BoldProps {
  children: ReactNode,
  style?: CSSProperties;
}
